{
    "JS_SDK_FUNCTION_CALL": {
        "eventId": 12,
        "adapter": "sdk",
        "src": 11,
        "sampleRatio": 1000,
        "params": {
            "visitor_id": "visitorUuid",
            "ver": "sdkVersion",
            "origin": "origin",
            "function_name": "fnName",
            "namespace": "namespace",
            "app_id": "appId",
            "instance_id": "instanceId",
            "is_published": "isPublished",
            "count": "count",
            "param": "param"
        }
    },
    "GALLERY_FUNCTION_CALL": {
        "eventId": 11,
        "adapter": "sdk",
        "src": 11,
        "params": {
            "visitor_id": "visitorUuid",
            "sdk_ver": "sdkVersion",
            "origin": "origin",
            "function_name": "fnName",
            "namespace": "namespace",
            "count": "count"
        }
    },
    "APP_STATE_CHANGED": {
        "eventId": 646,
        "src": 42,
        "params": {
          "widget_id": "widgetId",
          "instance_id": "compId",
          "appId": "appDefinitionId",
          "loading_time": "loadingTime",
          "pid": "pageId",
          "pn": "pageNo",
          "tts": "totalLoadingTime",
          "external_app_id": "externalAppDefinitionId",
          "external_widget_id": "externalWidgetId"
        }
    },
    "RELOAD_TPA_CLICK": {
      "eventId": 321,
      "src": 42,
      "params": {
        "app_id": "appDefinitionId",
        "appName": "appName"
      }
    },
    "APP_IS_ALIVE_ERROR": {
      "eventId": 405,
      "src": 42,
      "params": ["app_id", "errorMessage"]
    }
}
